
import { supabase } from "@/integrations/supabase/client";
import { useCallback } from "react";

/**
 * Interface for link counts data structure
 */
export interface LinkCountsData {
  [accountId: string]: {
    totalLinks: number;
    usedLinks: number;
  };
}

/**
 * Hook to handle API calls for fetching follow links data
 */
export const useLinkCountsApi = () => {
  /**
   * Fetch all follow links for given account IDs
   */
  const fetchFollowLinks = useCallback(async (accountIds: string[]) => {
    if (!accountIds.length) return { followLinks: [], error: null };
    
    console.log(`Fetching follow links for accounts:`, accountIds);
    
    const { data: followLinks, error } = await supabase
      .from('follow_link')
      .select('account_id, used, capacity, num_used')
      .in('account_id', accountIds);
    
    if (error) {
      console.error("Error fetching follow links:", error);
      return { followLinks: [], error };
    }
    
    console.log(`Retrieved ${followLinks?.length || 0} follow links`);
    return { followLinks, error: null };
  }, []);
  
  /**
   * Verify count for a specific account
   */
  const verifyAccountCount = useCallback(async (accountId: string) => {
    const { count, error } = await supabase
      .from('follow_link')
      .select('capacity')
      .eq('account_id', accountId);
    
    if (error) {
      console.error(`Error verifying count for account ${accountId}:`, error);
      return { count: null, error };
    }
    
    return { count, error: null };
  }, []);
  
  return {
    fetchFollowLinks,
    verifyAccountCount
  };
};
